<template>
  <div class="payment">
    <div style="width: 100%; display: flex;" justify-content-center>
        <div class="payment-container">
            <h5 style="margin:0;">Order Summary</h5>
            <br/>
            <h6 style="margin:0;">ITEMS</h6>
            <table>
                <tbody>
                    <tr>
                        <td>
                            Lawyerly Subscription -<br/>
                            {{getLabel}}
                        </td>
                        <td style="border-bottom: 1px solid #000;" class="price-col">
                            &#8369; {{getPrice}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Total
                        </td>
                        <td class="price-col">
                            &#8369; {{getPrice}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- <h6 style="margin: 15px 0 0 0">Pay with</h6> -->
            <ion-row v-if="!isLoading" class="sub-buttons">
                <ion-col size-md="12" size-lg="12" size-xs="12">

                   <p style="margin: 20px 0 0 0; text-align: center;">Do you have a <b>Lawyerly Voucher</b>?</p>
                   <ion-button fill="clear" expand="block" @click="payWithVoucher()">
                        Claim Lawyerly Voucher
                    </ion-button>
                    <ion-button style="margin: 30px 0 0 0;" expand="block" @click="paywithXendit()">
                        Checkout
                    </ion-button>
                    <!-- <p style="margin: 30px 0 0 0; text-align: center;">If you have a <b>Lawyerly Voucher</b>, click the button below.</p> -->
                   
                </ion-col>
            </ion-row>
            <ion-row v-else class="sub-buttons">
                <ion-col size-md="12" size-lg="12" size-xs="12" padding>
                  <ion-spinner style="margin: auto; display: block;" color="primary"></ion-spinner>
                </ion-col>
            </ion-row>
        </div>
    </div>
  </div>
</template>
<script>

import config from "../../config.js";

export default {
  data() {
    return {
      popupContent: false,
      plans: this.$config.plans,
      isLoading: false
    }
  },

  methods: {
    async payWithVoucher() {
      this.isLoading = true;
      const idx = this.plans.findIndex(p => p.type == this.$route.params.type);

      const doc = {
        type: this.$route.params.type,
        type_: this.plans[idx],
        payment: {
          type: 'voucher',
          label: 'Lawyerly Voucher',
          proof: {
            img: "",
            reference: "",
            date: ""
          }
        }
      };
      
      const res = await this.$http({
        method: "POST",
        url: config.api.url + "/subscribe",
        data: doc,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

      if(res) {
        if(res.data) {
          this.$router.push('/payment-update');
          return;
        }
      }
      
      setTimeout(async ()=>{
        this.isLoading = false;
        this.$ionic.showToast("Something went wrong.", {
          position: "bottom"
        });
      }, 800);
    },

    async paywithXendit() {
      this.isLoading = true;
      const idx = this.plans.findIndex(p => p.type == this.$route.params.type);

      let doc = {
        type: this.$route.params.type,
        type_: this.plans[idx],
        payment: {
          type: 'xendit',
            label: 'Xendit'
        }
      };

      if(this.$config.mobile) {
        doc.mobile = true;
      }
      
      const res = await this.$http({
        method: "POST",
        url: config.api.url + "/subscribe",
        data: doc,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

      if(res) {
        if(res.data) {
          const url = res.data.invoice_url;
          const cordova = window.cordova;
          if(cordova === undefined) {
              window.location.href = url;
          } else {
              var conf = "location=yes,zoom=no,hideurlbar=yes,hidenavigationbuttons=yes,toolbarcolor=#17b391,beforeload=get,closebuttoncolor=#ffffff";
              var ref = cordova.InAppBrowser.open(url, "_blank", conf);

              ref.addEventListener("exit", () => {
                  this.$router.push('/payment-done/error');
              });

              ref.addEventListener("beforeload", (params, callback) =>{
                  callback(params.url);

                  if(params.url.includes('success')) {
                    ref.addEventListener("exit", () => {
                      this.$router.push('/payment-done/success');
                    });
                  }

                  if(params.url.includes('failed')) {
                    ref.addEventListener("exit", () => {
                      this.$router.push('/payment-done/failed');
                    });
                  }

                  if (params.url.startsWith(this.$config.subscription.url)) {
                    setTimeout(()=>{
                      ref.close();
                    }, 2000);
                  }
              });
          }
        }
      }
      
      setTimeout(async ()=>{
        this.isLoading = false;
        this.$ionic.showToast("Something went wrong.", {
          position: "bottom"
        });
      }, 2000);
    }
  },
  computed: {
    getLabel() {
        const idx = this.plans.findIndex(p => p.type == this.$route.params.type);
        if(idx < 0) {
          return null;
        }
        return this.plans[idx].label.replace("<br/>", " ");
    },
    getPrice() {
        const idx = this.plans.findIndex(p => p.type == this.$route.params.type);
        if(idx < 0) {
          return null;
        }
        return this.plans[idx].price;
    }
  },

  mounted() {
    if(this.$route.params.type) {
      if(this.$route.params.type) {
        const idx = this.plans.findIndex(p => p.type == this.$route.params.type);
        if(idx < 0) {
          this.$router.push('/subscribe');
        }
      }
    }
  }
};
</script>

<style scoped>
  /* ion-button {
    color: #fff !important;
  } */
  ion-icon[name="checkmark-circle"] {
    color: #18bc9c;
  }

  ion-icon[name="close-circle"] {
    color: #ff5858;
  }

  .payment table {
      width: 100%;
  }

  .payment table tbody tr td {
    vertical-align: top;
    padding-top: 10px;
  }

  .sub-popup {
    padding: 1.25em 1em;
    width: 100%;
  }

  .sub-buttons {
    display: flex;
    width: 100%;
  }

  .sub-buttons button:before{
    content:'';
    float:left;
    padding-top:100%;
  }

  .sub-buttons button div{
   height: 100%;
  }

  .sub-buttons ion-button {
    margin: 0.5em 0;
  }

  .sub-buttons button div h3, .sub-buttons button div h4 {
    color: #ffffff;
    margin: 0 0 5px 0;
  }

  .sub-buttons button div h4 {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .price-col {
    padding: 0 5px 0 1.5em;
    text-align: right;
  }


  @media (min-width: 550px) {
    .payment-container {
      width: 450px;
    }
  }
</style>
